import { CustomSettingsContextProvider } from '../../../CustomSettings/Services/CustomSettingsContext';
import { CustomSettingKey } from '../../../Base/Enums/CustomSettingKey.enum';
import DataTable, {
	DataTableColumn,
} from '../../../Base/Components/DataTable/DataTable';
import React from 'react';
import { Document } from '../../../../graphql/graphql';
import { getSubmissionStatus } from '../../Helpers/sickLeaveStatusMap.helper';
import { getSickLeaveSubmissionSubTypeTx } from '../../Helpers/sickLeaveSubmissionSubType.helper';
import { FormattedDateTime } from '../../../../Components/FormattedDate';
import Text from '../../../../Components/Base/Text/Text';

interface Props {
	submissions: Document[];
}

const COLUMNS: DataTableColumn<Document, any>[] = [
	{
		key: 'submissionType',
		label:
			'component.CSSZSickLeaveCertificateSubmissionsOverview.submissionType',
		visible: true,
		renderItem: item => {
			const tx = getSickLeaveSubmissionSubTypeTx(item?.subType);
			return tx != null ? (
				<Text tx={tx} inline />
			) : (
				<span>{item?.subType}</span>
			);
		},
	},
	{
		key: 'status',
		label: 'component.CSSZSickLeaveCertificateSubmissionsOverview.status',
		visible: true,
		renderItem: item => {
			const status = getSubmissionStatus(item);
			return <Text tx={status?.translation} />;
		},
	},
	{
		key: 'createdAt',
		label: 'component.CSSZSickLeaveCertificateSubmissionsOverview.createdAt',
		visible: true,
		renderItem: item => <FormattedDateTime datetime={item.createdAt} />,
	},
	{
		key: 'submissionNumber',
		label:
			'component.CSSZSickLeaveCertificateSubmissionsOverview.submissionNumber',
		visible: true,
		renderItem: item => <span>{item?.code}</span>,
	},
];

const CSSZSickLeaveCertificateSubmissionsOverview = ({
	submissions = [],
}: Props) => {
	return (
		<CustomSettingsContextProvider
			customSettingsKey={CustomSettingKey.CSSZ_SICK_LEAVE_SUBMISSIONS_OVERVIEW}>
			<DataTable<Document, any>
				data={submissions}
				table={{}}
				columns={COLUMNS}
			/>
		</CustomSettingsContextProvider>
	);
};

export default CSSZSickLeaveCertificateSubmissionsOverview;
